import {useEffect} from 'react';

import {setOrganizationUserCards} from './setOrganizationUserCards';
import type {OrganizationUserCardOptions} from './types';

/**
 * Хук, позволяющий привязать ховер-карточки с информацией о пользователе к заданному
 * селектору внутри заданного контейнера.
 *
 * Примеры сценариев использования:
 * - для привязки карточек к элементам внутри статичной разметки;
 * - как единый механизм привязки карточек без необходимости точечного использования
 *   компонента OrganizationUserCard.
 */
export function useOrganizationUserCard(options: OrganizationUserCardOptions): void {
    const {
        containerRef,
        selector,
        route,
        cacheTTL,
        fetchUser,
        getUserId,
        disabled,
        className,
        onError,
    } = options;

    // содержимое эффекта вынесено в отдельную функцию, которую можно
    // использовать вне компонентов
    useEffect(() => setOrganizationUserCards(options), [
        containerRef,
        selector,
        route,
        cacheTTL,
        fetchUser,
        getUserId,
        disabled,
        className,
        onError,
    ]);
}

export * from './types';
export * from './setOrganizationUserCards';
